import styled from 'styled-components';
import { colors, fontSizes, fontWeights } from '@styles/utils';

export const GoogleMapsSliceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: ${fontSizes.large};
    font-weight: ${fontWeights.medium};
    color: ${colors.black};
    text-decoration: none;
    padding: 10px 20px;
    border: 1px solid ${colors.text};
    border-radius: 4px;
    transition: background-color 0.2s;

    &:hover {
      background-color: ${colors.text}20;
    }
  }
`;

export const GoogleMapsIcon = styled.span`
  font-size: 24px;
`;